var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center progressBar"},[_c('progreso',{attrs:{"avance":_vm.avanceParam}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }